const moneyFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false,
});

const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

function toNumeric(value) {
    const numeric = Number(value);
    return Number.isNaN(numeric) ? null : numeric;
}

/** Format a number to two decimal places (no grouping). For storage and calculations. */
function formatMoney(value) {
    const numeric = toNumeric(value);
    if (numeric === null) {
        return '';
    }
    return moneyFormatter.format(numeric);
}

/** Round a number to two decimal places. */
function roundMoney(value) {
    const numeric = toNumeric(value);
    if (numeric === null) {
        return NaN;
    }
    return Number(moneyFormatter.format(numeric));
}

/** Parse and format raw user input for editable money fields (no grouping). */
function formatMoneyDisplayValue(raw) {
    if (raw === '' || raw == null) {
        return '';
    }
    const parsed = parseFloat(String(raw).replace(/[^0-9.-]/g, ''));
    if (Number.isNaN(parsed)) {
        return String(raw);
    }
    return moneyFormatter.format(parsed);
}

/** Format a number as USD with grouping for read-only display. */
function formatCurrencyDisplay(value) {
    const numeric = toNumeric(value);
    if (numeric === null) {
        return '';
    }
    return currencyFormatter.format(numeric);
}

export { formatMoney, roundMoney, formatMoneyDisplayValue, formatCurrencyDisplay };
